<template>
  <div class="form-group">
    <label class="control-label">{{ label }}</label>
    <div class="input-group">
      <b-form-select
        v-model="startHour"
        :options="hourOptions"
        @input="handleInput"
      />
      <b-form-select
        v-model="startMin"
        :options="minOptions"
        @input="handleInput"
      />
    </div>
    <b-form-text v-if="description">{{ description }}</b-form-text>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
    hourOptions: {
      type: Array,
      required: false,
      default: () => [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
      ],
    },
    minOptions: {
      type: Array,
      required: false,
      default: () => [
        '00',
        '05',
        '10',
        '15',
        '20',
        '25',
        '30',
        '35',
        '40',
        '45',
        '50',
        '55',
      ],
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    let startHour = '09';
    let startMin = '00';
    if (this.value && this.value !== '') {
      // eslint-disable-next-line prefer-destructuring
      startHour = this.value.split(':')[0];
      // eslint-disable-next-line prefer-destructuring
      startMin = this.value.split(':')[1];
    }
    return {
      startHour,
      startMin,
    }
  },
  methods: {
    handleInput() {
      this.$emit('input', `${this.startHour}:${this.startMin}`);
    },
  },
}
</script>
